import { DropDown } from 'src/app/shared/model/base-model';
import { OnInit, Component, Input, Output, EventEmitter } from '@angular/core';
import { ScClaimService } from '../sc-claim.service';


@Component({
    selector: 'sf-sc-claim-dropdown-multi',
    templateUrl: './sc-claim-dropdown-multi.component.html',
    styleUrls: ['./sc-claim-dropdown-multi.component.scss']
})

export class ScClaimDropdownMultiComponent implements OnInit{

    public list : DropDown[];
    public item: DropDown;
    public selectedList: DropDown[];

    @Input() placeHolderLanguage: string;
    @Input() selectedItems: DropDown[] = [];
    @Output() chosedItem = new EventEmitter();



    constructor(  private scClaimService: ScClaimService){ }

    ngOnInit(): void {
        this.getList();

    }

    ngOnChanges(): void {
        this.selectedList = this.selectedItems;
    }


    getList() {
        this.scClaimService.getDropDownList().subscribe(
          {
            next: (res) => {
                if (res)
                    this.list = res.data;
                this.selectedList = this.selectedItems;

            },
            error: (err) => {
                console.log(`ClaimDropDownMulti - getList : ${err}.`);
            }
        });
      }

    feedback(){
        this.chosedItem.emit(this.selectedList)
    }

}
